<template>
  <!-- page-wrapper Start-->
  <div class="page-wrapper compact-wrapper" id="pageWrapper">
    <div class="page-body-wrapper">
      <div class="page-body">
        <!-- Breadcrumb & Title -->
        <div class="container-fluid">
          <div class="page-title">
            <div class="row">
              <div class="col-12 col-sm-6">
                <h3>Due Report</h3>
              </div>
              <div class="col-12 col-sm-6">
                <ol class="breadcrumb">
                  <li class="breadcrumb-item">
                    <a class="home-item" href="/"><i data-feather="home"></i></a>
                  </li>
                  <li class="breadcrumb-item">Dashboard</li>
                  <li class="breadcrumb-item">Report</li>
                  <li class="breadcrumb-item active">Due Report</li>
                </ol>
              </div>
            </div>
          </div>
        </div>
        <!-- Breadcrumb & Title -->

        <!-- Container-fluid starts-->
        <div class="container-fluid list-products">
          <div class="row">
            <!-- Create New -->
            <div class="col-sm-12 col-lg-12">
              <div class="card">
                <div class="card-header pb-0">
                  <h5>Filter Report</h5>
                </div>
                <div class="card-body">
                  <!-- <form> -->
                  <div class="row g-3">
                    <div class="col-md-4">
                      <label class="form-label" for="title">Customer</label>

                      <Select2
                        v-model="customer_id"
                        :options="customerList"
                        @change="myChangeEvent($event)"
                        @select="mySelectEvent($event)"
                      />
                    </div>
                    <div class="col-md-4">
                      <label class="form-label" for="title">Customer Type</label>
                      <Select2
                        v-model="customer_type"
                        :options="customerTypeList"
                        @select="mySelectTypeEvent($event)"
                      />
                    </div>
                    <div class="col-md-4">
                      <label class="form-label" for="title">Select District</label>
                      <Select2
                        v-model="district_id"
                        :options="districtList"
                        @select="mySelectDistrictEvent($event)"
                      />
                    </div>
                  </div>
                  <button class="btn btn-primary" type="submit" @click="onFilterAction">
                    Submit
                  </button>
                  <!-- </form> -->
                </div>
              </div>
            </div>

            <!-- Data table -->
            <div class="col-sm-12 col-lg-12" v-show="dueReport.length > 0">
              <div class="card">
                <div class="card-header pb-0">
                  <h5>List</h5>
                </div>
                <div class="card-body">
                  <div class="col-12 text-end">
                    <button class="btn btn-info my-3" @click="downloadPDF">
                      Download Report
                    </button>
                  </div>
                  <div class="table-responsive product-tabl">
                    <table class="display w-100" id="dueReportTBL">
                      <thead>
                        <tr align="center">
                          <th>#</th>
                          <th>Customer Name</th>
                          <th>Mushok</th>
                          <th>Overall Due</th>
                          <th>Invoice Due</th>
                          <th>Invoice type</th>
                          <th>Sub. Total</th>
                          <th>Total</th>
                          <th>Adjustment</th>
                          <!-- <th>Payment status</th> -->
                          <th>Invoice PDF</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          align="center"
                          v-for="(item, index) in dueReport"
                          :key="index"
                        >
                          <td>{{ item.inv_no }}</td>
                          <td>
                            {{
                              customerList
                                .map((e) => e.id === item.customer_id && e.name)
                                .filter(Boolean)
                                .toString()
                            }}
                          </td>
                          <td>{{ parseInt(item.mushok) }}</td>
                          <td>{{ parseInt(item.overall_due_amount) }}</td>
                          <td>{{ parseInt(item.inv_due_amount) }}</td>
                          <td>{{ item.inv_type ? "Manual" : "Automatic" }}</td>
                          <td>{{ parseInt(item.sub_total_price) }}</td>
                          <td>{{ parseInt(item.total_price) }}</td>
                          <td>{{ parseInt(item.adjustment_amount) }}</td>

                          <td>
                            <button
                              class="btn btn-sm btn-primary"
                              @click="downloadPDF(item)"
                            >
                              Download
                            </button>
                          </td>
                          <td>
                            <router-link
                              :to="'/invoice-details/' + item.id"
                              class="btn btn-primary btn-sm"
                              type="button"
                              data-original-title="btn btn-secondary btn-xs"
                              title=""
                              @click.prevent="updateType(item.id)"
                            >
                              Details
                            </router-link>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <div class="col-12 text-end mt-5">
                      <h5>Total Amount : {{ totalAmount ? totalAmount : "N/A" }}</h5>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Container-fluid starts-->
        <!-- Container-fluid starts-->
        <!-- Modal -->
        <div
          class="modal fade"
          id="exampleModal1"
          tabindex="-1"
          role="dialog"
          aria-labelledby="exampleModalLabel1"
          aria-hidden="true"
          v-show="this.selectedItem"
        >
          <div class="modal-dialog modal-dialog modal-md" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel1">Details</h5>
                <button
                  class="btn-close"
                  type="button"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div class="modal-body ct">
                <h5>Bank Name : {{ this.selectedItem.bank_name }}</h5>
                <hr />
                <h5>Bank Branch : {{ this.selectedItem.bank_branch }}</h5>
                <hr />
                <h5>Cheque Number : {{ this.selectedItem.cheque_number }}</h5>
                <hr />
                <h5>Cheque Date : {{ this.selectedItem.cheque_date }}</h5>
                <hr />
                <h5>Bkash Date : {{ this.selectedItem.bkash_date }}</h5>
                <hr />
                <h5>Bkash Transaction : {{ this.selectedItem.bkash_transaction_id }}</h5>
                <hr />
                <h5>Reference : {{ this.selectedItem.bkash_transfer_reference }}</h5>
                <hr />
                <h5>
                  Customer Type :
                  {{ this.selectedItem.customer_type == 1 ? "General" : "VIP" }}
                </h5>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "jquery/dist/jquery.min.js";
import "bootstrap/dist/css/bootstrap.min.css";
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import areaRelatedAPI from "../../../services/areaRelatedAPI.js";
import ReportAPI from "../../../services/report.API.js";
// import $ from "jquery";
import customerAPI from "../../../services/customer.API.js";
import moment from "moment";
import jsPDF from "jspdf";
import "jspdf-autotable";
import connectionTypeAPI from "../../../services/connectionType.API.js";
import Select2 from "vue3-select2-component";

export default {
  name: "dueReport",
  components: {
    Select2,
  },
  data() {
    return {
      customer_id: 0,
      customer_type: 0,
      district_id: 0,
      from_date: "",
      to_date: "",
      dueReport: [],
      districtList: [],
      customerList: [{ id: 0, text: "All" }],
      selectedItem: "",
      totalAmount: 0,
      customerTypeList: [{ id: 0, text: "All" }],
    };
  },

  methods: {
    myChangeEvent(val) {
      console.log(val);
    },
    mySelectEvent({ id, name }) {
      console.log({ id, name });
      this.customer_id = id;
    },
    mySelectTypeEvent({ id }) {
      this.customer_type = id;
    },
    mySelectDistrictEvent({ id }) {
      this.district_id = id;
    },
    // addNew
    onFilterAction() {
      //   console.log(this.title, this.status);
      // if (this.customer_id == "") {
      //   this.$moshaToast("Please enter Customer type", {
      //     type: "danger",
      //     position: "top-right",
      //     showIcon: true,
      //   });
      //   // this.customer_id = 0;
      // } else {
      let data = {
        customer_id: Number(this.customer_id),
        customer_type: this.customer_type ? Number(this.customer_type) : "",
        district_id: this.district_id ? Number(this.district_id) : "",
      };
      ReportAPI.getDueReport(data)
        .then((response) => {
          if (response?.data?.data?.length === 0) {
            this.$moshaToast("No data found", {
              type: "danger",
              position: "top-right",
              showIcon: true,
            });
            this.dueReport = response.data.data;
          }
          //   list
          this.totalAmount = response.data.totalAmount;
          this.dueReport = response.data.data;
          // .map((e) => {
          //   return {
          //     ...e,
          //     mr_date: moment(e.mr_date).format("MMMM DD, YYYY"),
          //     receive_date: moment(e.receive_date).format("MMMM DD, YYYY"),
          //     cheque_date: moment(e.cheque_date).format("MMMM DD, YYYY"),
          //     bkash_date: moment(e.bkash_date).format("MMMM DD, YYYY"),
          //   };
          // });
          // setTimeout(() => {
          //   $("#dueReportTBL").DataTable({
          //     lengthMenu: [
          //       [10, 25, 50, -1],
          //       [10, 25, 50, "All"],
          //     ],
          //     pageLength: 10,
          //     info: false,
          //     targets: "no-sort",
          //     bSort: false,
          //     order: [],
          //     bFilter: true,
          //     bInfo: false,
          //     //   bLengthChange: false,
          //     bDestroy: true,
          //   });
          // });
        })
        .catch((error) => {
          // console.log(error.response.data.success);
          if (error.response.data.success === false) {
            this.$moshaToast(error.response.data.message, {
              type: "danger",
              position: "top-right",
              showIcon: true,
            });
          }
        });
      // }
    },

    selectedAction(item) {
      this.selectedItem = item;
    },

    // download pdf
    downloadPDF(itemData) {
      if (itemData) {
        const unit = "pt";
        const size = "A4"; // Use A1, A2, A3 or A4
        const orientation = "portrait"; // portrait or landscape

        // header/body data
        const columns = [
          [
            "#",
            "Bill from date",
            "Bill to date",
            "Initial date",
            "Note",
            "Price",
            "Year",
          ],
        ];
        const data = itemData.items.map((e, i) => [
          i + 1,
          moment(e.bill_from_date).format("DD-MM-YYYY"),
          moment(e.bill_to_date).format("DD-MM-YYYY"),
          moment(e.initial_date).format("DD-MM-YYYY"),
          e.note,
          parseInt(e.price),
          e.year,
        ]);

        // alignment
        const marginLeft = 40;
        const doc = new jsPDF(orientation, unit, size);
        // new line
        // var pageWidth = doc.internal.pageSize.width || doc.internal.pageSize.getWidth();
        doc.setFontSize(13);

        doc.text("#" + itemData.inv_no, 40, 105);
        doc.setFontSize(10);

        doc.text("Mushok : " + parseInt(itemData.mushok), 40, 125);
        if (itemData.paid_status === 0) {
          doc.text("Payment Status : Unpaid", 40, 145);
        } else {
          doc.text("Payment Status : Paid", 40, 145);
        }
        doc.text("Sub-Total : " + parseInt(itemData.sub_total_price), 40, 165);
        doc.text("Total : " + parseInt(itemData.total_price), 40, 185);
        doc.setFontSize(15);
        var startingPage = doc.internal.getCurrentPageInfo().pageNumber;
        const title = "Report";

        let content = {
          startY: 220,
          head: columns,
          body: data,
          margin: {
            bottom: 120,
            top: 150,
          },
        };

        doc.setFont("helvetica", "bold");
        doc.setFontSize(15);
        doc.text(title, marginLeft, 50);

        doc.autoTable(content);

        doc.setPage(startingPage);
        doc.save("Invoice_Report(" + moment(new Date()).format("YYYY-MM-DD") + ").pdf"); // Auto print code
        doc.autoPrint();
      }
    },
  },
  mounted() {
    areaRelatedAPI.districtList().then((response) => {
      this.districtList = response.data.data?.map((e) => {
        return { ...e, text: e?.name };
      });
    });

    // customer list
    customerAPI.getList().then((response) => {
      this.customerList = [
        ...this.customerList,
        ...response?.data?.data?.map((e) => {
          return { ...e, text: e?.name };
        }),
      ];
    });
    // list
    connectionTypeAPI.typeActiveList().then((response) => {
      this.customerTypeList = [
        ...this.customerTypeList,
        ...response?.data?.data?.map((e) => {
          return { ...e, text: e?.title };
        }),
      ];
    });
  },
};
</script>

<style scoped>
@import url("https://unpkg.com/vue-next-select/dist/index.min.css");
thead,
tbody,
tfoot,
tr,
td,
th {
  border-color: #dbd4d4;
  border-style: solid;
  border-width: 1px;
  padding: 10px 5px;
}

.btn {
  margin: 5px;
}

th {
  text-align: center !important;
}

.card {
  border-radius: 1.5em;
  border: 1px solid white;
}

.card-header:first-child {
  border-radius: 1.5em;
}

.modal-backdrop.fade.show {
  opacity: 1 !important;
  display: none;
}

.modal-body.ct h5 {
  text-align: center;
}
</style>
